import { useEffect, useState } from 'react';
import { Button, Table, Spin, Tooltip } from 'antd';
import { Box } from '@mui/material';
import { Print } from '@mui/icons-material';
import InputForm from '../../InputT';
import Data from '../../../Data/Data.json';
import useEcheancierPret, { echeancierColumns, totauxFormFields } from '../../../Hooks/useEcheancierPret';
import PrintTabAmort from '../../Prints/PrintTabAmort';
import VersionEcheancierSelect from './VersionEcheancierSelect';

/**
 * Tableau d'amortissement partagé par les écrans de prêt.
 * Consultation uniquement : l'échéancier est généré en base par les
 * procédures stockées de chaque étape (demande, proposition, validation,
 * décaissement, modification). Ce composant recharge l'échéancier persisté
 * du dossier courant (charger) ou le vide quand l'écran est réinitialisé.
 */
const EcheancierPret = (props: { form?: any }) => {
    const { echeances, totaux, versions, version, loading, charger, afficherVersion, clear } = useEcheancierPret();
    const [printOpen, setPrintOpen] = useState(false);
    const [printCtx, setPrintCtx] = useState<{ numDos?: string, form?: any }>({});

    const ouvrirApercu = () => {
        const numDos = props.form?.getFieldValue('NUMDOS');
        if (!numDos) return;
        setPrintCtx({ numDos, form: { ...props.form.getFieldsValue(), titre: "TABLEAU D'AMORTISSEMENT N°" + numDos } });
        setPrintOpen(true);
    };

    useEffect(() => {
        const timer = setInterval(() => {
            try {
                if (localStorage.getItem(Data.LocalVariable.loadPret) === '1') {
                    localStorage.removeItem(Data.LocalVariable.loadPret);
                    const numDos = props.form?.getFieldValue('NUMDOS');
                    if (numDos) {
                        charger(numDos);
                    } else {
                        clear();
                    }
                }
            } catch (error) { }
            try {
                if (localStorage.getItem(Data.LocalVariable.reset) === '1') {
                    clear();
                }
                localStorage.removeItem(Data.LocalVariable.reset);
            } catch (error) { }
        }, 300);
        return () => clearInterval(timer);
    }, [charger, clear, props.form]);

    useEffect(() => {
        props.form?.setFieldsValue(totauxFormFields(totaux));
    }, [totaux]);

    return (
        <div className='tabItem'>
            <div>
                <Box fontStyle="inherit" className='border' height={"60%"} width={"85%"} position={"absolute"}>
                    <div className='clientP'>
                        <div>
                            <Box fontStyle="inherit" className='border-left tabElement' position="static" height="auto" width="100%">
                                {/* Sélecteur de version à gauche, bouton d'impression à droite */}
                                <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" marginBottom="6px">
                                    <VersionEcheancierSelect
                                        versions={versions}
                                        version={version}
                                        onSelect={(v) => afficherVersion(v)}
                                    />
                                    <Tooltip title="Aperçu / Imprimer">
                                        <Button size='small' icon={<Print style={{ fontSize: 16 }} />} onClick={ouvrirApercu} disabled={echeances.length === 0} />
                                    </Tooltip>
                                </Box>
                                <Spin spinning={loading}>
                                    <Table size='small' style={{ width: '100%' }} columns={echeancierColumns} dataSource={echeances} scroll={{ y: 220, x: 'max-content' }} pagination={false} />
                                </Spin>
                                <Box display="flex" flexWrap="nowrap" gap={0.5} width="100%" marginTop="8px" fontStyle="inherit" className='border-left bordure1 tabElement2' alignItems="center" position="relative" top={0}>
                                    <InputForm notRequired disabled width={8} label='Amort' name='TotAm' type='text' error='mobile' />
                                    <InputForm notRequired disabled width={8} label='Intéret' name='TotIt' type='text' error='mobile' />
                                    <InputForm notRequired disabled width={8} label='TVA' name='TotTaxe' type='text' error='mobile' />
                                    <InputForm notRequired disabled width={8} label='AHT' name='TotAnnuite' type='text' error='mobile' />
                                    <InputForm notRequired disabled width={8} label='ATTC' name='TotAnTTC' type='text' error='mobile' />
                                    <InputForm notRequired disabled width={8} label='Epargne' name='TotEpargn' type='text' error='mobile' />
                                </Box>
                            </Box>
                        </div>
                        <div>
                        </div>
                    </div>
                </Box>
            </div>
            <PrintTabAmort open={printOpen} onClose={() => setPrintOpen(false)} numDos={printCtx.numDos} form={printCtx.form} />
        </div>
    );
};

export default EcheancierPret;
